import React from "react";
import { Helmet } from "react-helmet";

import Page from "../../components/layout/Page";

//@ts-ignore
import showroomBg from "../../assets/images/showroom-hero.jpg";
//@ts-ignore
import cat1 from "../../assets/images/montaj.jpg";
//@ts-ignore
import img4 from "../../assets/images/pages/4.jpg";

export default function Montaj() {
  return (
    <Page>
      {
        //@ts-ignore
        <Helmet>
          <title>Montaj & Instalare Sisteme Smart Home | Asempera Cluj</title>
          <meta
            name="description"
            content={`Echipa Asempera asigură montaj profesionist și punere în funcțiune pentru case inteligente în Cluj-Napoca și România. Instalăm cu precizie fiecare componentă pentru un sistem perfect funcțional.`}
          />
        </Helmet>
      }
      <div
        className="page-title with-background"
        style={{ backgroundImage: `url(${cat1})` }}
      >
        <div className="shade"></div>
        <h1>Montaj & punere în funcțiune</h1>
      </div>
      <div className="an-section">
        <div className="an-content flex align-center">
          <div className="an-col w-6">
            <h2>De la plan, la realitate:</h2>
            <p>
              Proiectul tău tehnic este gata, visul tău prinde contur pe hârtie.
              Acum urmează pasul unde expertiza noastră ca{" "}
              <strong>parteneri oficiali Loxone</strong>, face diferența:
              transformarea planului într-un ecosistem inteligent, perfect
              funcțional.
            </p>
            <p className="mb-0">
              Momentul execuției este cel în care viziunea devine interactivă.
              Aici, precizia tehnică și atenția la detalii fac diferența dintre
              un sistem care "merge" și unul care te uimește în fiecare zi.
              Echipa noastră de tehnicieni specializați în instalarea sistemelor
              smart home preia ștafeta cu o singură misiune: să se asigure că{" "}
              <strong>totul funcționează perfect</strong>, exact cum am promis,
              încă din prima zi. Tratăm fiecare casă cu respectul pe care îl
              merită, lucrând curat, eficient și în{" "}
              <strong>strânsă comunicare cu tine</strong>.
            </p>
          </div>
          <div className="an-col w-6">
            <img src={img4} className="max-400 center"></img>
          </div>
        </div>
      </div>
      <div id="showroom">
        <div
          className="bg-section"
          style={{ backgroundImage: `url(${showroomBg})` }}
        ></div>
        <div className="shade"></div>
        <div className="an-section">
          <div className="an-content flex center">
            <div className="an-col w-8 text">
              <p>
                Fie că ai deja un proiect tehnic sau ești la început de drum,
                echipa noastră de experți este pregătită să preia partea de
                execuție cu maximă seriozitate și profesionalism. Contactează-ne
                pentru a stabili o întâlnire și a discuta concret despre
                proiectul tău.
              </p>
              <a
                className="special-button"
                style={{ marginTop: 16 }}
                href="/#contact"
              >
                Hai să discutăm proiectul tău.
              </a>
            </div>
            <div className="an-col w-4 blank"></div>
          </div>
        </div>
      </div>
    </Page>
  );
}
